import React from "react"
import styled, { keyframes } from "styled-components/macro"

const fadeInBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100%)
  }
  100% {
    opacity: 1;
  }
`
const ExpandedBox = styled.div`
position: relative;
  width: auto;
  min-width: 320px;
  flex: 1;
  display: flex;
    flex-direction: column;
    align-items: center;
  height: max-height;
  background: ${({ theme }) => theme.expandedBackground};
  border-radius: 34px;
  opacity: 1;
  padding: 3px;
  margin: 16px;
  animation: ${fadeInBottom} 1s ease-in-out;
`

const Title = styled.h2`
  font-weight: 800;
  font-size: 18px;
  text-align: center;
  color: ${({ theme }) => theme.headerSubtitle};
  margin: 36px 0 0 0;
`

const Description = styled.h3`
  font-size: 12px;
  color: ${({ theme }) => theme.description};
  opacity: 0.5;
  text-align: center;
  white-space: pre-wrap;
  margin: 4px 21px;
  font-weight: 500;
`

const SubDescription = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.description};
  opacity: 0.54;
  text-align: center;
  font-style: italic;
  padding: 0 21px;
  margin: 0;
  line-height: 1.2;
`

const ImageContainer = styled.div`
  margin-top: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const FloatContainer = styled.div`
  position: absolute;
  display: inline-block;
  width: auto;
  height: auto;
  margin: 0;
`
const StatsBox = styled.div`
  width: 100%;
  height: auto;
  flex:1;
  background: ${({ theme }) => theme.statsBackground};
  border-radius: 32px;
  padding: 24px;
  margin-top: 16px;
`
export const ImageBox = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: space-around;
`
const Stats = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  justify-content: space-between;
  margin: 0 0 8px 0;
  &:last-child {
    margin: 0;
  }
`
const StatName = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.description};
  text-align: left;
  opacity: 0.65;
  margin: 0;
`
const Value = styled.p`
  font-weight: normal;
  color: ${({ theme }) => theme.description};
  text-align: right;
  margin: 0;
`

export default props => {
  const stats = props.data.stats[0]

  return (
    <ExpandedBox theme={props.theme} style={{ width: "150px" }}>
      <ImageContainer>
        <FloatContainer css={`animation: none`}>
          <img
            src={require(`../images/${props.type}/${props.data.name
              .toLowerCase()
              .split(" ")
              .join("")
              .replace("!", "")}.png`)}
            alt={props.data.name}
            style={{
              width: "auto",
              height: props.primal ? "275px" : "100px",
              margin: 0,
            }}
          />
        </FloatContainer>
      </ImageContainer>

      <br></br>

      <Title theme={props.theme}>{props.data.name}</Title>
      <Description theme={props.theme}>{props.data.description}</Description>
      <SubDescription theme={props.theme}>{props.data.quote}</SubDescription>

      <StatsBox theme={props.theme}>
        {props.data.banner ? (
          <ImageBox>
            <img
              src={require(`../images/Banners/${props.data.banner
                .toLowerCase()
                .split(" ")
                .join("")
                .replace("!", "")}.png`)}
              alt={props.data.name}
              style={{
                width: "auto",
                height: "55px",
                margin: 0,
              }}
            />
          </ImageBox>
        ) : null}
        {typeof stats === "string" ? (
          <StatsBox theme={props.theme}>
            {props.data.stats.map((stat, index) => (
              <SubDescription theme={props.theme} key={index}>
                {index + 1}. {stat}
              </SubDescription>
            ))}
          </StatsBox>
        ) : stats && typeof stats.name === "string" ? (
          props.data.stats.map((stat, index) => (
            <Stats theme={props.theme} key={index}>
              <StatName theme={props.theme}>{stat.name}</StatName>
              <Value theme={props.theme}>{stat.value}</Value>
            </Stats>
          ))
        ) : (
          stats.stats &&
          stats.stats.map((stat, index) => (
            <Stats theme={props.theme} key={index}>
              <StatName theme={props.theme}>{stat.name}</StatName>
              <Value theme={props.theme}>{stat.value}</Value>
            </Stats>
          ))
        )}
      </StatsBox>
    </ExpandedBox>
  )
}
